module.exports = __webpack_public_path__ + "line-awesome.3f85d8035b4ccd91d2a1.eot";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/line-awesome/line-awesome.eot?v=1.1.
// module id = ../../../../../src/assets/vendors/base/fonts/line-awesome/line-awesome.eot?v=1.1.
// module chunks = styles